export default __webpack_public_path__ + "assets/mp3/20a906a8d391381c4c282c3632b49caa.mp3";